<template>
    <div class="yq-time-interval-picker" v-bind="$attrs">
        <div class="yq-time-interval-picker-container">
            <el-select class="yq-time-interval-picker-type-select" v-model="parsedValue.type" :size="size" @input="onInput">
                <el-option value="relative" label="最近"></el-option>
                <el-option value="absolute" label="固定值"></el-option>
            </el-select>
            <el-time-picker v-if="parsedValue.type === 'absolute'" v-model="parsedValue.range" @input="onInput"
                            :size="size" is-range ></el-time-picker>
            <el-input v-if="parsedValue.type === 'relative'" v-model.number="parsedValue.amount" @input="onInput"
                      :size="size" type="number"></el-input>
            <el-select v-if="parsedValue.type === 'relative'" class="yq-time-interval-picker-unit-select"
                       v-model="parsedValue.unit" @input="onInput" :size="size">
                <el-option v-for="item in timeUnits" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import dateUtils from '../../service/date-utils'
    export default {
        name: "DateIntervalPicker",
        props: {
            value: String,
            size: {
                type: String,
                default: 'mini'
            }
        },
        inheritAttrs: false,
        data(){
            return {
                timeUnits: dateUtils.timeUnitsForTime,
                parsedValue: dateUtils.parseTimeInterval(this.value)
            }
        },
        watch:{
            value(newValue){
                const oldValue = this.format(this.parsedValue)
                if(oldValue===newValue){
                    return
                }
                this.parsedValue = dateUtils.parseTimeInterval(this.value)
            }
        },
        methods: {
            format(value){
                if(value.type==='relative'){
                    if(!value.amount){
                        return null
                    }
                    const duration = moment.duration(value.amount, value.unit)
                    return duration.toISOString()
                }else{
                    if(!value.range||value.range.length===0){
                        return null
                    }
                    return value.range.map(dateUtils.formatTime).join('/')
                }
            },
            onInput(){
                if(this.parsedValue.amount!==null && this.parsedValue.amount!==undefined && this.parsedValue.amount!==''){
                    if(this.parsedValue.amount<1){
                        this.parsedValue.amount = 1
                    }else{
                        this.parsedValue.amount = Number(Number(this.parsedValue.amount).toFixed(0))
                    }
                }
                this.$emit('input', this.format(this.parsedValue))
                if(this.parsedValue.type==='relative'){
                    if(!this.parsedValue.amount){
                        this.parsedValue.range = null
                    }else{
                        this.parsedValue.range = [
                            moment().subtract(this.parsedValue.amount, this.parsedValue.unit).valueOf(),
                            moment().valueOf()]
                    }
                }else{
                    if(!this.parsedValue.range||this.parsedValue.range.length===0){
                        this.parsedValue.amount = null
                    }else{
                        const duration = moment.duration(moment(this.parsedValue.range[1])
                            .diff(moment(this.parsedValue.range[0])))
                        const parsedDuration = dateUtils.parseDuration(duration, dateUtils.timeUnitsForTime)
                        this.parsedValue.amount = parsedDuration.amount
                        this.parsedValue.unit = parsedDuration.unit
                    }
                }
            }
        }
    }
</script>
